import { getCookieData } from "@/utils";
import { baseApi, envs } from "@/utils/constants";
import { Fetcher } from "@/utils/fetcher";
import axios, { AxiosResponse } from "axios";

const page = new Fetcher("pages", envs.s3Bucket);
const builder = new Fetcher(undefined, envs.s3Bucket);
page.setUseToken(false);

const REVALIDATE = Number(process.env.PAGE_DATA_REVALIDATE) || 300;

// isomorphic GET: hits Next's data cache on the server (5-min revalidate)
const cachedGet = async <T = any>(url: string): Promise<T> => {
  const res = await fetch(url, {
    next: { revalidate: REVALIDATE },
  } as RequestInit);
  if (!res.ok) throw new Error(`Request failed: ${res.status} ${url}`);
  return res.json();
};

// get builder page
export const getBuilderPage = (slug: string): Promise<BuilderPage> =>
  cachedGet<BuilderPage>(`${envs.baseApiUrl}pages/${slug}`);

// get builder item by route name and slug
// export const getBuilderItem = (
//   routeName: BucketRoute,
//   slug: string
// ): Promise<any> => {
//   // return builder.get<any>(`${routeName}/${slug}.json`);
//   return new Promise(async (resolve, reject) => {
//     try {
//       const response = await axios.get(
//         `${envs.s3Bucket}${routeName}/${slug}.json`
//       );
//       resolve(response.data);
//     } catch (err) {
//       reject(err);
//     }
//   });
// };

export const getBuilderItem = (
  routeName: BucketRoute,
  slug: string
): Promise<any> => cachedGet(`${envs.baseApiUrl}${routeName}/${slug}`);



export const getWelcomePopup = async (): Promise<BuilderPage> => {
  const url = `${envs.baseApiUrl}/widgets/welcome-popup/randoms`;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) throw new Error(`Request failed: ${res.status} ${url}`);
  return res.json();
};

// export const getBuilderPage = (slug: string): Promise<BuilderPage> => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       console.log(`${envs.s3Bucket}pages/${slug}.json`);
//       const response = await axios.get(`${envs.s3Bucket}pages/${slug}.json`);
//       resolve(response.data);
//     } catch (err) {
//       reject(err);
//     }
//   });
// };


export const getBuilderDraftPage = (
  pageId: string,
  token?: string
): Promise<BuilderPage> => {
  if (!token) token = getCookieData(envs.adminTokenKey);

  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(baseApi + `page/${pageId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      resolve(res.data);
    } catch (error) {
      reject(error);
    }
  });
};
